import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const EVALUACIONES_CONST = 'evaluaciones';
export const evaluacionesApi = `${baseUrl}/${EVALUACIONES_CONST}`;

export const allEvaluacionesService = async (params) => {
  const res = await axios.get(evaluacionesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEvaluacionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${evaluacionesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(evaluacionesApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEvaluacionesService = async (id) => {
  const res = await axios.get(`${evaluacionesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEvaluacionesService = async (id) => {
  const res = await axios.delete(`${evaluacionesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
